import { CabecalhoDaTela, PainelDaAba, useAbaAtual, type Aba } from "../componentes/Abas.js";
import { IconeDiagnostico, IconeNumeros } from "../componentes/icones.js";
import { Diagnostico } from "./Diagnostico.js";
import { Estatisticas } from "./Estatisticas.js";

/**
 * Números — o que foi medido, e onde dói (RN-30).
 *
 * Estatísticas responde "quanto e como está indo"; o diagnóstico responde "em
 * que eu erro". A segunda pergunta é a que se faz **depois** de ver a primeira,
 * e as duas eram destinos separados na barra — a leitura completa exigia
 * lembrar que a outra existia.
 */
const ABAS: readonly Aba[] = [
  {
    id: "evolucao",
    rotulo: "Evolução",
    glifo: IconeNumeros,
    descricao: "Quanto você respondeu, com que acerto, e como isso andou no tempo.",
  },
  {
    id: "diagnostico",
    rotulo: "Diagnóstico",
    glifo: IconeDiagnostico,
    descricao: "Onde o erro se concentra, e o pedido pronto para gerar itens sobre isso.",
  },
];

export function Numeros() {
  const [aba, escolher] = useAbaAtual(ABAS);

  return (
    <>
      <CabecalhoDaTela
        titulo="Números"
        rotulo="Recortes dos números"
        abas={ABAS}
        atual={aba}
        aoEscolher={escolher}
      />
      <PainelDaAba id={aba} className="">
        {aba === "evolucao" && <Estatisticas />}
        {aba === "diagnostico" && <Diagnostico />}
      </PainelDaAba>
    </>
  );
}
